import React from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { PAYMENT_STATUS_COLORS, LATE_PAYMENT_COLORS } from 'constants';
import { PAYMENT_STATUS_OPTIONS, PAYMENT_STATUS } from './constants';

export const PaymentStatusChip = ({
  status,
  effective_status,
  is_overdue,
  paid_late,
  days_late
}) => {
  const getLabel = (statusValue) => {
    const option = PAYMENT_STATUS_OPTIONS.find(opt => opt.value === statusValue);
    return option ? option.label : statusValue;
  };

  // Use effective_status if available (handles OVERDUE display), otherwise use status
  const displayStatus = effective_status || status;
  const displayLabel = getLabel(displayStatus);
  const displayColor = PAYMENT_STATUS_COLORS[displayStatus] || '#808080';

  // For PAID status, show additional late payment information
  if (status === PAYMENT_STATUS.PAID && paid_late !== undefined && paid_late !== null) {
    return (
      <Stack direction="row" spacing={1} alignItems="center">
        <Chip
          label={displayLabel}
          size="small"
          style={{
            backgroundColor: displayColor,
            color: 'white',
          }}
        />
        {paid_late && (
          <Chip
            label={days_late ? `Late +${days_late}d` : 'Paid Late'}
            size="small"
            variant="outlined"
            style={{
              borderColor: LATE_PAYMENT_COLORS.LATE,
              color: LATE_PAYMENT_COLORS.LATE,
              fontSize: '0.75rem'
            }}
          />
        )}
      </Stack>
    );
  }

  return (
    <Chip
      label={displayLabel}
      size="small"
      style={{
        backgroundColor: displayColor,
        color: 'white',
      }}
    />
  );
};